import * as stylex from "@stylexjs/stylex";
import { foldLocale } from "locales";
import dynamic from "next/dynamic";
import React from "react";
import { SearchComponent, SearchInput } from "./dynamicComponent";
export const Search = ({ locale })=>{
    const [query, setQuery] = React.useState("");
    const IDX = query ? localizedIndex(locale) : ()=>null;
    return <div className="x1n2onr6" onBlur={(e)=>{
        const currentTarget = e.currentTarget;
        setTimeout(()=>{
            if (!currentTarget.contains(document.activeElement)) {
                setQuery("");
            }
        }, 200);
    }}>
      <SearchComponent>
        <SearchInput value={query} onChange={(e)=>{
        setQuery(e.currentTarget.value);
    }}/>
      </SearchComponent>
      {query && <IDX query={query}/>}
    </div>;
};
const Loading = ()=>{
    return <div className="x10l6tqk">...</div>;
};
const localizedIndex = foldLocale({
    ar: dynamic(()=>import("../../search/output/index.ar"), {
        ssr: false,
        loading: Loading
    }),
    de: dynamic(()=>import("../../search/output/index.de"), {
        ssr: false,
        loading: Loading
    }),
    en: dynamic(()=>import("../../search/output/index.en"), {
        ssr: false,
        loading: Loading
    }),
    es: dynamic(()=>import("../../search/output/index.es"), {
        ssr: false,
        loading: Loading
    }),
    fr: dynamic(()=>import("../../search/output/index.fr"), {
        ssr: false,
        loading: Loading
    }),
    ru: dynamic(()=>import("../../search/output/index.ru"), {
        ssr: false,
        loading: Loading
    }),
    zh: dynamic(()=>import("../../search/output/index.zh"), {
        ssr: false,
        loading: Loading
    })
});
